import { __ } from '@wordpress/i18n';
import { queryClient, queryKeys } from '../../lib/query-client';
import RecSessionService from '../../service/rec-session-service';
import displayNetworkError from '../../helpers/displayNetworkError';
import handleSuccessAndDisplay from '../../helpers/handleSuccessAndDisplay';

export const makeRecSessionActions = (set, get, { cacheRecSessionAudioImpl, cleanupRecSessionAudioImpl } = {}) => {
    const fetchRecSessionsImpl = async (projectId) => {
        set('recSessionsLoading', true);
        set('recSessionsError', null);

        try {
            const data = await queryClient.fetchQuery({
                queryKey: queryKeys.recSessions(projectId),
                queryFn: () => RecSessionService.getRecSessionsAsync(projectId),
            });

            set('recSessions', data);
            set('recSessionsLoading', false);
        } catch (error) {
            set('recSessionsError', error);
            set('recSessionsLoading', false);
            displayNetworkError(error);

            if (!error?.handled) {
                throw error;
            }
        }
    };

    return {
        fetchRecSessions: fetchRecSessionsImpl,

        uploadRecSessionTrack: async (projectId, recSessionId, formData, type, subType) => {
            try {
                const body = new FormData();
                body.append('file', formData.file);

                const payload = {};
                if (formData.title) payload.title = formData.title;
                if (formData.label) payload.label = formData.label;
                body.append('Payload', JSON.stringify(payload));

                const queryParams = [['type', type]];
                if (subType) queryParams.push(['subType', subType]);

                const updatedSession = await RecSessionService.uploadTrackAsync(projectId, recSessionId, body, queryParams);

                set('recSessions', get('recSessions').map(s => s.id === recSessionId ? updatedSession : s));

                if (get('selectedRecItemId') === recSessionId) {
                    cleanupRecSessionAudioImpl?.();
                    await cacheRecSessionAudioImpl?.(projectId, updatedSession);
                }

                await queryClient.invalidateQueries({ queryKey: queryKeys.recSessions(projectId) });

                handleSuccessAndDisplay(__('Traccia caricata con successo', 'soundbetween'));

                return updatedSession;
            } catch (error) {
                displayNetworkError(error);

                if (!error?.handled) {
                    throw error;
                }
            }
        },

        createRecSession: async (projectId, body) => {
            try {
                const newSession = await RecSessionService.createRecSessionAsync(projectId, body);

                set('recSessions', [...get('recSessions'), newSession]);

                await queryClient.invalidateQueries({ queryKey: queryKeys.recSessions(projectId) });

                handleSuccessAndDisplay(__('Registrazione creata con successo', 'soundbetween'));

                return newSession;
            } catch (error) {
                displayNetworkError(error);

                if (!error?.handled) {
                    throw error;
                }
            }
        },
    };
};
